import { Pipe, PipeTransform } from '@angular/core';
import { RichDevice } from '@store';
import { ElectricHeaterHelper } from '../electric-heater.helper';

@Pipe({
  name: 'electricHeaterSelectHeatingRodIndex',
  standalone: true,
})
export class ElectricHeaterSelectHeatingRodIndexPipe implements PipeTransform {
  transform(
    device: RichDevice,
    heatingRodsData: ElectricHeaterHelper.HeatingRodIndexWithBoilerSerial[]
  ): string {
    return heatingRodsData.find((heatingRod) => heatingRod.deviceId === device.id)?.heatingRodIndex;
  }
}
